export enum LineageRelationType {
  DERIVED_FROM = 'derived_from',
  INSPIRED_BY = 'inspired_by',
  CRITIQUE_OF = 'critique_of',
  IMPLEMENTATION_OF = 'implementation_of',
  REFINEMENT_OF = 'refinement_of',
  ALTERNATIVE_TO = 'alternative_to'
}

export interface LineageNode {
  id: string;
  artifact_id: string;
  name: string;
  type: string;
  created_at: string;
  agent_name: string;
  version: number;
  phase?: string;
  metadata?: Record<string, any>;
}

export interface LineageEdge {
  id: string;
  source_id: string;
  target_id: string;
  type: LineageRelationType;
  created_at: string;
  metadata?: Record<string, any>;
}

export interface LineageGraph {
  nodes: LineageNode[];
  edges: LineageEdge[];
  root_id: string;
}
